import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { resolveAvatarsByIdentifierRpc, setAvatarOverrideRpc, clearAvatarOverrideRpc } from '../../__generated__/chirp/com/hubspot/avatars/rpc/AvatarsRpc';
import invariant from 'react-utils/invariant';
import { arrayBufferToBase64 } from '../lib/arrayBufferToBase64';
import { LOOKUP_TYPE_TO_OBJECT_TYPE_ID } from '../Constants';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
const SOURCE_ID = 'CRM_UI';
function resolveObjectTypeId(objectType) {
  const objectTypeId = LOOKUP_TYPE_TO_OBJECT_TYPE_ID[objectType];
  invariant(objectTypeId, 'Unknown objectType "%s" — expected one of: %s', objectType, Object.keys(LOOKUP_TYPE_TO_OBJECT_TYPE_ID).join(', '));
  return objectTypeId;
}
export function callResolveAvatarsByIdentifier(request) {
  return rpcClient.call(resolveAvatarsByIdentifierRpc, {
    request
  });
}
export function callSetAvatarOverride(objectType, objectId, imageData) {
  const objectTypeId = resolveObjectTypeId(objectType);
  return rpcClient.call(setAvatarOverrideRpc, {
    request: {
      sourceId: SOURCE_ID,
      imageData: arrayBufferToBase64(imageData),
      objectTypeAndId: {
        objectTypeId,
        objectId
      }
    }
  });
}
export function callClearAvatarOverride(objectType, objectId) {
  const objectTypeId = resolveObjectTypeId(objectType);
  return rpcClient.call(clearAvatarOverrideRpc, {
    request: {
      sourceId: SOURCE_ID,
      objectTypeAndId: {
        objectTypeId,
        objectId
      }
    }
  });
}